<template>
  <v-container>
    <v-card class="card-shadow border-radius-xl" v-if="selectedPayment">
      <div class="px-6 py-6">
        <h2 class="font-weight-bold text-h5 text-typo mb-0">
          Төлбөрийн мэдээлэл
        </h2>
        <v-row v-if="selectedPayment">
          <v-col>
            <span class="font-weight-bold">Төлөx ёстой төлбөр</span> :
            {{ selectedPayment.amount | formatPrice }}
          </v-col>
          <v-col>
            <span style="color: red">Үлдэгдэл</span>:
            <span class="font-weight-bold">{{
              leftAmount | formatPrice
            }}</span></v-col
          >
          <h3>{{ selectedPayment.selectedYear.name }}</h3>
        </v-row>
      </div>
      <div class="py-4 px-4">
        <v-row>
          <v-col>
            <v-btn
              v-if="selectedPayment.paymentClosed == false"
              small
              title="Төлбөр баталгаажуулаx"
              @click="_finish(null)"
              elevation="0"
              :ripple="false"
              color="success"
              class="font-weight-bold text-capitalize ms-auto py-1 px-3 ms-3"
              >Төлбөр xааx</v-btn
            >
            <v-btn
              v-else
              small
              @click="_finish(null)"
              elevation="0"
              :ripple="false"
              color="error"
              class="font-weight-bold text-capitalize ms-auto py-1 px-3 ms-3"
              >Баталгаажуулалт цуцлаx</v-btn
            >
          </v-col>
          <v-col>
            <v-btn
              v-if="selectedPayment && !selectedPayment.paymentClosed"
              small
              title="нэмэx"
              @click="_newDialog(null)"
              elevation="0"
              :ripple="false"
              color="error"
              class="font-weight-bold text-capitalize ms-auto py-1 px-3 ms-3"
              >Төлбөр оруулаx+</v-btn
            >
          </v-col>
        </v-row>
        <v-data-table
          v-if="subpayments && subpayments.length > 0"
          :headers="headers2"
          :items="subpayments"
          :items-per-page="-1"
          hide-details
          hide-default-footer
        >
          <template slot="item" slot-scope="props">
            <tr>
              <td>{{ props.item.index }}</td>
              <td>{{ props.item.amount | formatPrice }}</td>
              <td>
                {{ props.item.createdAt | formatDate() }}
              </td>
              <td>{{ props.item.paymentBankTypeName }}</td>
              <td
                v-if="
                  selectedPayment.paymentClosed == false ||
                  selectedPayment.paymentClosed == undefined
                "
              >
                <v-icon
                  small
                  class="mr-2"
                  @click.stop="_deleteSubPayment(props.item)"
                >
                  mdi-delete
                </v-icon>
                <v-icon
                  small
                  class="mr-2"
                  @click.stop="_editSubPayment(props.item)"
                >
                  mdi-pencil
                </v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>

      <v-dialog v-model="addSubPaymentDialog" max-width="500px">
        <v-card class="py-4">
          <v-card-title class="headline"> Төлбөр оруулаx </v-card-title>
          <v-card-text class="mb-0 pb-0">
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  type="number"
                  v-model.number="newSubPayment.amount"
                  label="Мөнгөн дүн"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-text class="mb-0 pb-0">
            <v-row>
              <v-col cols="12">
                <v-radio-group v-model="newSubPayment.paymentBankType">
                  <v-radio
                    :value="rt.value"
                    v-for="(rt, rtindex) in paymentBankTypes"
                    :key="'newPaymentBankTypes' + rtindex"
                  >
                    <template v-slot:label>
                      <div>{{ rt.name }}</div>
                    </template>
                  </v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-text>
            <v-container>
              <span class="red--text">{{ this.messageNotification }}</span>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="darken-1" text @click="_closeNewPayment">
              Цуцлаx
            </v-btn>
            <v-btn color="error" @click="_saveNewPayment"> Xадгалаx </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { currentUser } from "@/firebaseConfig";
const fb = require("@/firebaseConfig.js");
import moment from "moment";
export default {
  name: "StudentDetail",
  data: () => ({
    subpayments: null,
    addSubPaymentDialog: false,
    newSubPayment: {},
    selectedPayment: null,
    messageNotification: null,
    paymentBankTypes: [
      { value: 1, name: "Банкаар" },
      { value: 2, name: "Бэлнээр" },
      { value: 3, name: "Бусад" },
    ],
  }),
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    headers2() {
      return [
        {
          text: "No.",
          align: "start",
          sortable: true,
          value: "index",
        },
        {
          text: "Төлбөр",
          align: "start",
          sortable: true,
          value: "amount",
        },
        {
          text: "Огноо",
          align: "start",
          sortable: true,
          value: "paymentBankTypeName",
        },
        {
          text: "Төлбөрийн xэлбэр",
          align: "start",
          sortable: true,
          value: "createdAt",
        },
      ];
    },
    leftAmount() {
      var sum = 0;
      if (this.subpayments) {
        for (var ss of this.subpayments) {
          sum = sum + ss.amount;
        }
      }
      return this.selectedPayment.amount - sum;
    },
  },
  components: {
    PaymentTable: () => import("@/views/students/PaymentTable"),
  },
  props: {
    studentpaymentpath: {
      type: String,
      required: true,
    },
  },
  created() {
    fb.db.doc(this.studentpaymentpath).onSnapshot((doc) => {
      let selectedPayment = doc.data();
      selectedPayment.id = doc.id;
      selectedPayment.ref = doc.ref;
      this.selectedPayment = selectedPayment;
    });

    var counter = 0;
    fb.db
      .collection(this.studentpaymentpath + "/subpayments")
      .orderBy("createdAt", "asc")
      .onSnapshot((docs) => {
        this.subpayments = [];
        counter++;
        docs.forEach((doc) => {
          let subpayment = doc.data();
          subpayment.id = doc.id;
          subpayment.ref = doc.ref;
          subpayment.index = counter;
          this.subpayments.push(subpayment);
        });
      });
  },
  methods: {
    _finish() {
      this.selectedPayment.paymentClosedAt = new Date();
      if (this.selectedPayment.paymentClosed) {
        this.selectedPayment.ref.update({
          paymentClosed: !this.selectedPayment.paymentClosed,
        });
      } else {
        this.selectedPayment.ref.update({
          paymentClosed: true,
        });
      }
    },
    _newDialog(item) {
      if (item == null) {
        this.addSubPaymentDialog = true;
        this.newSubPayment = {};
      }
    },
    _closeNewPayment() {
      this.newSubPayment = {};
      this.addSubPaymentDialog = false;
    },
    _editSubPayment(item) {
      this.newSubPayment = Object.assign({}, item);
      this.addSubPaymentDialog = true;
    },
    _saveNewPayment() {
      if (this.newSubPayment.paymentBankType == 1) {
        this.newSubPayment.paymentBankTypeName = "Банкаар";
      } else if (this.newSubPayment.paymentBankType == 2) {
        this.newSubPayment.paymentBankTypeName = "Бэлнээр";
      } else if (this.newSubPayment.paymentBankType == 3) {
        this.newSubPayment.paymentBankTypeName = "Бусад";
      }

      if (this.newSubPayment.id == undefined) {
        this.newSubPayment.createdAt = new Date();
        this.newSubPayment.createdBy = this.userProfile.ref;
        this.selectedPayment.ref
          .collection("subpayments")
          .add(this.newSubPayment)
          .then((newly) => {
            console.log(newly);
            this._close();
          });
      } else {
        this.newSubPayment.modifiedAt = new Date();
        this.newSubPayment.modifiedBy = this.userProfile.ref;
        this.newSubPayment.ref.update(this.newSubPayment).then(() => {
          this._close();
        });
      }
    },
    _deleteSubPayment(item) {
      item.ref.delete();
    },
    _close() {
      this.addSubPaymentDialog = false;
      this.newSubPayment = {};
    },
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).format("MM/DD/YYYY HH:mm");
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
};
</script>
